module.exports = __webpack_public_path__ + "static/img/game-logo.81fcc97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/zh/h5/imgs/game-logo.png
// module id = /8es
// module chunks = 13